<template>
	<el-dialog @closed="clearPrj" title="样品详情" append-to-body :visible.sync="visible" :close-on-click-modal="false" width="976px" height="750px">
		<div style="position: relative;">
			<el-divider content-position="left">样品信息</el-divider>
		</div>
		<form-template :formDisabled="isDisabled" style="width: 95%;margin: 0 auto;" ref="dataForm" :mod="mod" :orderId="orderId || cartId"></form-template>
		<div style="position: relative;display: flex;align-items: center;">
			<el-divider content-position="left">检项信息</el-divider>
			<el-button v-if="['inspection','cart'].includes($route.name) || ['dtj'].includes($route.query.state)" :disabled="!prjChecks.length" style="padding: 0;width: 64px;margin-left: 10px;height: 28px;border-radius: 14px;font-weight: bold;" type="danger" @click="delRow">删除</el-button>
			<el-button v-if="['inspection','cart'].includes($route.name) || ['dtj'].includes($route.query.state)" style="width: 64px;padding: 0;margin-left: 10px;border-radius: 14px;height: 28px;font-weight: bold;" type="primary" round size="small" @click="openItems" :disabled="dataListLoading">添加</el-button>
		</div>
		<el-table @selection-change="handleSelectionChange" :data="tableData" v-loading="dataListLoading" style="width: 100%">
			<el-table-column v-if="['inspection','cart'].includes($route.name) || ['dtj'].includes($route.query.state)" type="selection" width="45" align="center"></el-table-column>
			<el-table-column v-for="(v, i) in tableHeader" :key="i" :prop="v.field" :label="v.label" :width="v.options.width">
				<template slot-scope="{ row }">
					<el-input @clear="saveTableInput(v,row)" @blur="saveTableInput(v,row)" v-if="v.options && v.options.cellType && v.options.cellType === 'input'" type="text" v-model="row[`${v.field}_newVal`]" clearable :maxlength="v.options && v.options.maxlength"></el-input>
					<span v-else :style="{color:v.options.color}">
						{{row[v.field]}}
					</span>
				</template>
			</el-table-column>
		</el-table>
		<div slot="footer">
			<!-- <p style="margin-bottom: 16px;font-size: 18px;color: #FF6F77;font-weight: bold;text-align: center;">合计：{{totalPrice}}</p> -->
			<el-button :disabled="!sampleIndex" v-if="!isDisabled" @click="preOrNext(1)">上一个</el-button>
			<el-button v-if="!isDisabled" type="primary" @click="dataFormSubmit(0)">确 定</el-button>
			<el-button :disabled="sampleIndex == allSample.length-1" v-if="!isDisabled" @click="preOrNext(2)">下一个</el-button>
		</div>
		<!-- 编辑样品-添加检项 -->
		<add-item v-if="additemVisible" ref="additemVisible" @addPrj="addPrj"></add-item>
	</el-dialog>
</template>

<script>
	import { downloadFile } from "@/utils";
	import AddItem from "./addItem.vue";
	import formTemplate from "@/components/formTemplate.vue"
	export default {
		components: {
			AddItem,
			formTemplate
		},
		data() {
			return {
				tableHeader: [],
				tableData: [],
				dataListLoading: false,
				active: 0,
				additemVisible: false,
				title: '',
				visible: false,
				orderId: '',
				sampleId: '',
				cartId: '',
				isDisabled:false,
				totalPrice:0.00,
				mod: {
					formData:{
						list:[]
					}
				},
				allSample:[],
				sampleIndex:'',
				updateMod:{
					formData:{
						list:[]
					}
				},
				ypTypekey:'',
				saved:false,
				prjChecks:[]
			};
		},
		computed: {
			upAddr() {
				return window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload';
			}
		},
		methods: {
			saveTableInput(header,row){
				console.log(row[header.field] , row[`${header.field}_newVal`]);
				if(row[header.field] != row[`${header.field}_newVal`]){
					let url = this.cartId ? this.$api.orderApi.cartSaveSample : this.$api.orderApi.updateOrder;
					let params = {}
					params[`${header.groupCode}.${header.field}`] = row[`${header.field}_newVal`];
					const { id, objId } = row;
					params.id = id;
					params.objId = objId;
					if(this.cartId){
						params.cartId = this.cartId
					}
					if(this.orderId){
						params.orderId = this.orderId;
					}
					this.$http.post(url, params).then(({
						data
					}) => {
						this.$message({
							message: data.msg,
							type: 'success'
						});
					})
				}
			},
			freshPrice(){
				this.totalPrice = 0.00;
				this.tableData.forEach(v=>{
					this.totalPrice += Number(v.costVal);
				});
				this.totalPrice = this.totalPrice.toFixed(2);
			},
			handleSelectionChange(rows){
				this.prjChecks = rows;
			},
			preOrNextThen(st){
				st == 1 ? this.sampleIndex-- : this.sampleIndex++;
				let row = this.allSample[this.sampleIndex];
				if(this.orderId){
					let formConfig = JSON.parse(JSON.stringify(this.mod.formData.list));
					this.mod = {
						formData:{
							list:[]
						}
					};
					Object.keys(row).forEach(key => this.$set(this.mod.formData,key,row[key]));
					formConfig.forEach(item => {
						this.$set(item,'val',row[item.field]);
					});
					this.mod.formData.list = formConfig;
					// 保存样品id
					this.sampleId = row.id;
					// 获取检项列表
					this.getPrj();
					//保存初始化时表单
					this.updateMod = JSON.stringify(this.mod);
					this.$nextTick(()=>{
						this.$refs['dataForm'].$refs.formRef.clearValidate();
					});
					return
				}
				this.cartEditSample(row.id,this.allSample,this.sampleIndex);
			},
			preOrNext(st){
				if(this.updateMod != JSON.stringify(this.mod)){
					this.$confirm("是否保存当前编辑？", "提示", {
						confirmButtonText: "保存",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						this.dataFormSubmit(st);
					}).catch(()=>{
						this.preOrNextThen(st);
					});
					return
				}
				this.preOrNextThen(st);
			},
			downloadFile(url, fileName) {
				downloadFile(url, fileName);
			},
			clearPrj(){
				this.tableData = [];
				this.$refs.dataForm.$refs.formRef.resetFields();
				this.saved && this.$emit('refreshDataList');
			},
			addPrj(prjs) {
				if(this.cartId){
					this.$http.post(this.$api.orderApi.cartAddPrj, {
						cartId:this.cartId,
						projectIds: prjs.map(v=>{return String(v.projectId)})
					}).then(() => {
						this.$message({
							message: "添加成功",
							type: "success"
						});
						this.$refs.additemVisible.dialogVisible = false;
						this.cartEditSample(this.cartId,this.allSample,this.sampleIndex,1);//只刷新检项
						// 刷新价格
						this.$emit('freshPrice');
					});
					return
				}
				let params = {
					orderId: this.orderId,
					id: this.sampleId,
					projectIds: prjs.map(v=>{return String(v.projectId)})
				}
				this.$http.post(this.$api.orderApi.sampleAddPrj, params).then(() => {
					this.$message({
						message: "添加成功",
						type: "success"
					});
					this.$refs.additemVisible.dialogVisible = false;
					this.getPrj();
					// 刷新价格
					this.$emit('freshPrice');
				});
			},
			openItems() {
				this.additemVisible = true;
				this.$nextTick(() => {
					this.$refs.additemVisible.init(this.orderId, "editeSample",this.tableData.map(v=>{return Number(v.objId)}),this.allSample[this.sampleIndex]);
				});
			},
			delRow() {
				this.$confirm(`确定进行["删除"]操作?`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let param = {
						ids: this.prjChecks.map(v=>v.id)
					};
					param[this.cartId?'cartId':'orderId'] = this[this.cartId?'cartId':'orderId']
					this.$http.post(this.$api.orderApi[this.cartId?'cartDelPrj':'sampleInfoDelPrj'], param).then(() => {
						this.$message({
								message: "删除成功",
								type: "success"
							});
							if(this.cartId){
								this.cartEditSample(this.cartId,this.allSample,this.sampleIndex,1);//1，只刷新检项
							}else{
								this.getPrj();
							}
							// 刷新价格
							this.$emit('freshPrice');
					});
				});
			},
			getPrj() {
				this.dataListLoading = true;
				let param = {
					orderId: this.orderId,
					pid: this.sampleId,
					moduleKey: "YPXQ_JX"
				}
				this.$http.post(this.$api.orderApi.getPrjBySample, param).then(({
					data
				}) => {
					this.dataListLoading = false;
					data.data.forEach(item =>{
						if(item.layout == "TABLE"){
							this.tableHeader = item.header.filter(v => v.showed == true) || [];
							// 设置输入框绑定字段
							item.data.forEach(v=>{
								this.tableHeader.forEach(h=>{
									if(h.options && h.options.cellType && h.options.cellType === 'input'){
										v[`${h.field}_newVal`] = v[h.field];
									}
								})
							})
							this.tableData = item.data || [];
							// this.freshPrice();
						}
					})
				}).catch(()=>{
					this.dataListLoading = false;
				});
			},
			// 购物车编辑
			cartEditSample(id,all,index,freshPrj) {
				this.allSample = all;
				this.sampleIndex = index;
				this.dataListLoading = true;
				// 保存购物车id
				this.cartId = id;
				this.$http.get(this.$api.orderApi.cartSampleDetail,{params:{cartId:id}}).then(({
					data
				}) => {
					this.dataListLoading = false;
					this.visible = true;
					data.data.forEach(data=>{
						// 表单详情
						if(data.layout == "FORM" && !freshPrj){
							let list = data.list.filter(v => v.showed == true);
							this.mod = {
								formData:{
									list:list
								}
							}
							list.forEach(item=>{
								this.$set(this.mod.formData,item.field,item.val)
							})
							setTimeout(() => {
								this.updateMod = JSON.stringify(this.mod);//保存初始化时表单(下拉异步之后)
							}, 500);
							this.$nextTick(()=>{
								this.$refs['dataForm'].$refs.formRef.clearValidate();
							});
						}
						// 检项表头+列表
						if(data.layout == "TABLE"){
							this.tableHeader = data.header.filter(v => v.showed == true) || [];
							// 设置输入框绑定字段
							data.data.forEach(v=>{
								this.tableHeader.forEach(h=>{
									if(h.options && h.options.cellType && h.options.cellType === 'input'){
										v[`${h.field}_newVal`] = v[h.field];
									}
								})
							})
							this.tableData = data.data || [];
							// this.freshPrice();
						}
					})
				}).catch(()=>{
					this.dataListLoading = false;
				});
			},
			// 样品编辑
			editSample(orderId, row, showConfig,isDisabled,ypTypekey,all,index) {
				this.ypTypekey = ypTypekey;
				this.allSample = all;
				this.sampleIndex = index;
				this.orderId = orderId;
				this.isDisabled = isDisabled;
				this.mod.formData = JSON.parse(JSON.stringify(row));
				this.mod.formData.list = [];
				// 保存样品id
				this.sampleId = row.id;
				// 样品详情表单配置
				showConfig.forEach(item => {
					if(['select','radio'].includes(item.type) && !item.options.url){
						// 列表行的中文需要转（排除异步获取下拉情况）
						let ops = item.options.valueData.filter(v=>v.label == row[item.field]);
						row[item.field] = ops && ops.length ? ops[0].code : '';
					}
					if(item.type == 'checkbox'){
						let ops = item.options.valueData.filter(v=>row[item.field].includes(v.label));
						row[item.field] = ops.map(v=>v.code);
					}
					this.$set(item,'val',row[item.field]);
					this.$set(this.mod.formData, item.field, item.val);
				});
				this.mod.formData.list = showConfig;
				// 获取检项列表[图片]添加删除按钮[图片]添加删除按钮
				this.getPrj();
				this.visible = true;
				//保存初始化时表单(下拉异步之后)
				setTimeout(() => {
					this.updateMod = JSON.stringify(this.mod);
				}, 500);
			},
			dataFormSubmit(st) {
				this.$refs['dataForm'].$refs.formRef.validate((valid) => {
					if (valid) {
						let url = this.cartId ? this.$api.orderApi.cartSaveSample : this.$api.orderApi.updateOrder;
						let params = {
							...this.$refs['dataForm'].getFormData()
						};
						if(this.cartId){
							params.cartId = this.cartId
						}
						if(this.orderId){
							const { id, objId } = this.$refs['dataForm'].mod.formData;
							params.id = id;
							params.objId = objId;
							params.orderId = this.orderId;
						}
						this.$http.post(url, params).then(({
							data
						}) => {
							this.$message({
								message: data.msg,
								type: 'success'
							});
							this.saved = true;//保存过就要刷新父组件
							if(this.allSample.length==1){
								this.visible = false;
								return
							}
							this.updateMod = JSON.stringify(this.mod);//重新保存表单
							Object.keys(this.mod.formData).forEach(key=>key!='list' && (this.allSample[this.sampleIndex][key] = this.mod.formData[key]));
							st && this.preOrNextThen(st);
						});
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-dialog{
		margin-top: 10vh!important;
    	height: 750px;
		.el-dialog__footer {
			padding-top: 22px;
			padding-bottom: 26px;
			margin-top:0;
			.el-button {
				width: 80px;
				line-height: 38px;
				border-radius: 20px;
				font-size: 14px;
			}
		}
		.el-dialog__body{
			padding-top: 12px;
			overflow: auto;
			height: calc(100% - 183px);
		}
	}
	
	.upload-demo {
		display: flex;
		width: 100%;
		border: 1px solid;
		border: 1px solid #dcdfe6;
		overflow: hidden;

		button {
			padding: 9px 15px;
			margin: 8px 5px 0px 0px;
		}

		.el-scrollbar {
			max-width: 230px;
		}
	}

	.el-select {
		width: 100%;
	}
	.btns{
		position: absolute;
		right: 50px;
		top: 12px;
		.el-button{
			padding: 0 10px;
			border-radius: 20px;
			line-height: 32px;
			&:hover,&:focus{
				border: 1px solid #dcdfe6;
    			color: #606266;
				background: #fff;
			}
			&.is-disabled:hover{
				color: #c0c4cc;
    			border-color: #ebeef5;
			}
		}
	}
	::v-deep .cell .el-input{
		.el-input__suffix i.el-input__icon.el-icon-circle-close.el-input__clear{
			line-height: 23px;
		}
		.el-input__inner{
			border: 1px solid #DEDEDE;
			color: #333333;
			border-radius: 4px;
			height: 23px;
			line-height: 23px;
		}
	} 
</style>
